import { Container, Grid } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React, { Fragment } from "react";
import paymentSolutionsImage from "assets/images/YOOZ-payment-solutions-image.png";
import signUp_img from "assets/images/home_content_2.png";
import ContentImageBlock from "components/public-dashboard/components/contentImageBlock";
import ContentList from "components/public-dashboard/components/contentList";
import PrimaryText from "components/public-dashboard/components/primaryText";
import { API_ROOT } from "constants/actionTypes";
import HomeHeader from "../home/header";
import StoryBeanBagImg from "assets/images/STORIES-BEAN-BAG.png"
import TextList from "../../components/TextList";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import QuoteContainer from "../../../shared/quote_container"
import {reviewData} from "./reviews/constants";
import {actionRoutes} from "../../appbar/constants";
import {Link} from "react-router-dom";
import {setTabPosition} from "../../uiSlice";
const useStyles = makeStyles((theme) => ({
  media: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  featureImg: {
    [theme.breakpoints.up("md")]: {
      height: 110,
      width: 110,
    },
    height: 30,
    width: 30,
  },
  gatewayFeatures: {
    [theme.breakpoints.up("md")]: {
      marginLeft: 40,
      marginBottom: 48,
    },
    paddingLeft: 16,
  },

    container: {
        background: "#F2F2F2",
        margin: "auto",
        paddingTop: 20,
    },
}));

export default function PartnersContent(props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <Container>
      <Fragment>
        <Grid container direction="row" justify="center" alignItems="center">

            <Grid container item spacing={2} justify="center" alignItems="center">
                {reviewData.map(review => (
                    <Grid item xs={12} md={6}>
                        <Card className={classes.root}>
                            <CardActionArea>
                                <CardContent>
                                  <img src={review.logo} style={{width: "auto", height: 100}}/>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        <QuoteContainer
                                            text={review.previewQuote.text}
                                            name={review.previewQuote.title}
                                        />
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                            <CardActions>
                                <Button
                                    color="secondary"
                                    variant={"outlined"}
                                    to={"/case-studies/"+review.url}
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                    }}
                                    component={Link}
                                >
                                    Learn More
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}

                {reviewData.length % 2 !== 0 && (<Grid item xs={12} md={6} container justify="center" direction="row" alignItems="center">
                  <img src={StoryBeanBagImg} style={{width: "auto", height: "350px"}} />
                </Grid>)}
            </Grid>
        </Grid>
      </Fragment>
    </Container>
  );
}
